import _ from 'lodash'

class AccessToken {
  constructor() {}

  static factory($resource, $log, config) {
    return $resource(
      config.authenticationEndpoint + "/token",
      {},
      {
        login: {
          method: 'POST',
          withCredentials: true
        },
        logout: {
          url: config.authenticationEndpoint + "/sign-out",
          method: 'POST',
          withCredentials: true
        }
      }
    )
  }
}

AccessToken.factory.$inject = ['$resource', '$log', 'config']

export default AccessToken
